import { TextEllipsis } from '@app/components/various/TextEllipsis';
import { getIsMenuItemActive } from '@app/logic/navigation';
import { cn } from '@app/utils/cn';
import { Link, useLocation } from 'react-router-dom';

interface Props {
  id?: string;
  link: string;
  isExternal?: boolean;
  name: string;
  onClick?: () => void;
}

export const MenuItem = ({ link, name, id, isExternal, onClick }: Props) => {
  const { pathname } = useLocation();
  const isActive = getIsMenuItemActive(link, pathname);

  return (
    <li key={link}>
      <Link
        id={id}
        to={link}
        className={cn(
          'block w-full rounded-regular px-2 py-[0.375rem] transition-colors body-2 hover:bg-neutral-96 focus-visible:focus-outline',
          {
            'bg-neutral-96 body-1 hover:bg-neutral-90': isActive,
          },
        )}
        target={isExternal ? '_blank' : undefined}
        onClick={onClick}
      >
        <TextEllipsis as="div">{name}</TextEllipsis>
      </Link>
    </li>
  );
};
